module.exports = __webpack_public_path__ + "img/icon_production_es.bb1ab8a5.png";